import { Component } from '@verndale/core';
import Cookies from 'js-cookie';
import { open, close } from '../helpers/motion';

class CookieDisclaimer extends Component {
  setupDefaults() {
    this.dom = {
      acceptButton: this.el.querySelectorAll('.cookie-banner__accept-btn')
    };

    this.id = this.el.id;
    this.cookieName = `mcphs_cookie_${this.id}`;
    this.shouldDisplayCookieBanner();
  }

  addListeners() {
    this.dom.acceptButton?.forEach(button =>
      button.addEventListener('click', this.handleClick.bind(this))
    );
  }

  shouldDisplayCookieBanner() {
    if (Cookies.get(this.cookieName)) {
      return this.el.remove();
    }
    this.el.style.display = 'block';
    open(this.el);
  }

  handleClick(e) {
    e.preventDefault();
    Cookies.set(this.cookieName, this.id, {
      expires: parseInt(this.el.dataset.cookieExpiration, 10) || 1
    });
    close(this.el).finished.then(() => {
      this.el.remove();
    });
  }
}

export default CookieDisclaimer;
